import {Form, Input} from "antd";
import {FC, useEffect} from "react";
import {StatisticItemFormProps} from "./types";
import {VALIDATION_MESSAGES} from "../../../../enums/validationMessages";
import TextArea from "antd/es/input/TextArea";
import "./style.less"

const StatisticItemForm: FC<StatisticItemFormProps> = (props) => {
  const {statisticController} = props
  const {form, selectedStatisticItem} = statisticController

  useEffect(() => {
    if (selectedStatisticItem) {
      form.setFieldsValue(selectedStatisticItem)
    } else {
      form.resetFields()
    }
  }, [selectedStatisticItem])


  return (
    <Form form={form} layout="vertical" className="statisticItem_form"
          onFinish={statisticController.submitButtonHandler}>
      <Form.Item name="value" label="Показник" rules={[{required: true, message: VALIDATION_MESSAGES.REQUIRED}]}>
        <Input/>
      </Form.Item>
      <Form.Item name="title" label="Заголовок" rules={[{required: true, message: VALIDATION_MESSAGES.REQUIRED}]}>
        <Input/>
      </Form.Item>
      <Form.Item name="description" label="Опис" rules={[{required: true, message: VALIDATION_MESSAGES.REQUIRED}]}>
        <TextArea rows={3}/>
      </Form.Item>
    </Form>
  )
}

export default StatisticItemForm